module.exports = __webpack_public_path__ + "static/logo-b64e76ef96f1bc213c9c73b0e516dcd9.webp";